export default function ImpressumPage() {
  return (
    <div className="bg-white" data-testid="impressum-page">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-normal text-[#2c3e50] mb-4">Impressum</h1>
        <hr className="mb-8 border-gray-300" />

        <div className="text-[#2c3e50] leading-relaxed">
          {/* Angaben gemäß § 5 TMG */}
          <section className="mb-8">
            <h2 className="text-lg font-semibold mb-3">Angaben gemäß § 5 TMG:</h2>
            <p>M.Sc.-Psych. Katharina Langer</p>
            <p>Psychologische Psychotherapeutin</p>
            <p>Butenwall 52A</p>
            <p>46325 Borken</p>
          </section>

          {/* Kontakt */}
          <section className="mb-8">
            <h2 className="text-lg font-semibold mb-3">Kontakt</h2>
            <p>Telefon: +49 15751336474</p>
            <p>E-Mail: <a href="mailto:Psychotherapie-Praxis-langer@gmx.de" className="text-[#3498db] hover:underline">Psychotherapie-Praxis-langer@gmx.de</a></p>
          </section>

          {/* Aufsichtsbehörde */}
          <section className="mb-8">
            <h2 className="text-lg font-semibold mb-3">Zuständige Aufsichtsbehörde:</h2>
            <p>Psychotherapeutenkammer NRW</p>
            <p>Willstätterstraße 10 | 40549 Düsseldorf</p>
            <p>Tel.: 0211/5228470, Fax: 0211/52284715</p>
            <p>Internet: <a href="http://www.ptk-nrw.de" target="_blank" rel="noopener noreferrer" className="text-[#3498db] hover:underline">www.ptk-nrw.de</a></p>
          </section>

          {/* Berufsrechtliche Regelungen */}
          <section className="mb-8">
            <h2 className="text-lg font-semibold mb-3">Es gelten folgende berufsrechtliche Regelungen:</h2>
            <p>Berufsordnung der Psychotherapeutenkammer NRW</p>
            <p className="mt-2">Regelungen einsehbar unter: <a href="http://www.bptk.de/uploads/media/20060117_musterberufsordnung.pdf" target="_blank" rel="noopener noreferrer" className="text-[#3498db] hover:underline break-all">www.bptk.de</a></p>
          </section>

          {/* Gesetzliche Berufsbezeichnung */}
          <section className="mb-8">
            <h2 className="text-lg font-semibold mb-3">Gesetzliche Berufsbezeichnung</h2>
            <p>Approbation als Psychologische Psychotherapeutin, verliehen in der Bundesrepublik Deutschland.</p>
          </section>

          {/* Kassenärztliche Vereinigung */}
          <section className="mb-8">
            <h2 className="text-lg font-semibold mb-3">Zuständige Kassenärztliche Vereinigung:</h2>
            <p>KV Westfalen Lippe</p>
            <p>Robert-Schimrigk-Straße 4-6 | 44141 Dortmund</p>
            <p>Körperschaft des öffentlichen Rechts</p>
            <p>Internet: <a href="https://kvwl.de" target="_blank" rel="noopener noreferrer" className="text-[#3498db] hover:underline">kvwl.de</a></p>
          </section>

          {/* Umsatzsteuer */}
          <section className="mb-8">
            <h2 className="text-lg font-semibold mb-3">Angaben zur Umsatzsteuer:</h2>
            <p>Psychotherapeutische Leistungen sind umsatzsteuerbefreit, gemäß §4 Nr. 14 UStG.</p>
          </section>

          {/* Berufshaftpflichtversicherung */}
          <section className="mb-8">
            <h2 className="text-lg font-semibold mb-3">Angaben zur Berufshaftpflichtversicherung:</h2>
            <p className="mb-2">Name und Sitz der Gesellschaft:</p>
            <p>ALTE LEIPZIGER</p>
            <p>Alte Leipziger-Platz 1</p>
            <p>61440 Oberursel</p>
            <p className="mt-2">Geltungsraum der Versicherung: Deutschland</p>
          </section>

          <hr className="my-10 border-gray-300" />

          {/* Haftungsausschluss */}
          <h2 className="text-2xl font-normal text-[#2c3e50] mb-6">Haftungsausschluss</h2>

          <section className="mb-8">
            <h3 className="text-lg font-semibold mb-3">Haftung für Inhalte</h3>
            <p className="text-justify">
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den 
              allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch 
              nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach 
              Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur 
              Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben 
              hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis 
              einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen 
              werden wir diese Inhalte umgehend entfernen.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-lg font-semibold mb-3">Haftung für Links</h3>
            <p className="text-justify">
              Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss 
              haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte 
              der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. 
              Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. 
              Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente 
              inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer 
              Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige 
              Links umgehend entfernen.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-lg font-semibold mb-3">Urheberrecht</h3>
            <p className="text-justify">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem 
              deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der 
              Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des 
              jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, 
              nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber 
              erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter 
              als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam 
              werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen 
              werden wir derartige Inhalte umgehend entfernen.
            </p>
          </section>

          <p className="text-sm text-gray-500 mt-8">
            Quelle: <a href="https://www.e-recht24.de" target="_blank" rel="noopener noreferrer" className="hover:underline">e-recht24.de</a>
          </p>
        </div>
      </div>
    </div>
  );
}
